export const PASSWORD_RECOVERY_ATTEMPT = 'PASSWORD_RECOVERY_ATTEMPT';
export type PASSWORD_RECOVERY_ATTEMPT = typeof PASSWORD_RECOVERY_ATTEMPT;

export const PASSWORD_RECOVERY_SUCCESS = 'PASSWORD_RECOVERY_SUCCESS';
export type PASSWORD_RECOVERY_SUCCESS = typeof PASSWORD_RECOVERY_SUCCESS;

export const PASSWORD_RECOVERY_FAILURE = 'PASSWORD_RECOVERY_FAILURE';
export type PASSWORD_RECOVERY_FAILURE = typeof PASSWORD_RECOVERY_FAILURE;

export const PASSWORD_RECOVERY_CLEAR_ERRORS = 'PASSWORD_RECOVERY_CLEAR_ERRORS';
export type PASSWORD_RECOVERY_CLEAR_ERRORS = typeof PASSWORD_RECOVERY_CLEAR_ERRORS;


// WEBPACK FOOTER //
// ./src/actions/authentication/password-recovery/Types.tsx